import { api, commonApi } from '../../api/common.js'
import reportApi from '../../api/reportsAPI'
import serverApi from '../../api/serverAPI'
const datas = {
  getClassroom: (arg) => new Promise((resolve, reject) => {
    api.get('/tc-products/2/variants/' + arg)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getClassrooms: (args) => new Promise((resolve, reject) => {
    
    api.get('tc-products/2/variants')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  createClassroom: ({...args}) => new Promise((resolve, reject) => {
    var data = {}
    data.data = args
    api.post('tc-products/2/variants',data)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  deleteClassroom: (varId) => new Promise((resolve, reject) => {

    api.post('/tc-products/2/variants/' + varId + '/delete')
        .then(function (response) {
          resolve(response.data.data)
        })
        .catch((error) => {
          reject(error)
        })
  }),
  updateClassroom: ({ ...args}) => new Promise((resolve, reject) => {
    var data = {}
    data.data = args
    api.post('/tc-products/2/variants/' + args.id, data)
        .then(function (response) {
          resolve(response.data.data)
        })
        .catch((error) => {
          reject(error)
        })
  }),
  getVenues: (args) => new Promise((resolve, reject) => {
    console.log(args)
    api.get('venues/filter/?limit='+args.limit+'&skip='+args.skip+'&orderBy='+args.orderBy+'&orderDirection='+args.orderDirection+'&town='+args.town+'&countryId='+args.country)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  updateVenue: (args) => new Promise((resolve, reject) => {
    var data = {}
    data.data = args
    api.post('venues/'+args.id,data)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getVenuesByTown: (args) => new Promise((resolve, reject) => {
    api.get('venues/filter/?town='+args)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
  ,
  getCountries: () => new Promise((resolve, reject) => {
    api.getCountries()
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getTutorName: (id) => new Promise((resolve, reject) => {
    commonApi.getUserLongnameById(id)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getTutor: (id) => new Promise((resolve, reject) => {
    commonApi.getUserById(id)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getTutors: (args) => new Promise((resolve, reject) => {
    //?limit='+args.limit+'&skip='+args.skip+'&orderBy='+args.orderBy+'&orderDirection='+args.orderDirection+'&town='+args.town+'&countryId='+args.country
    console.log('gettuors')
    api.get('/users/filter/?limit='+args.limit+'&skip='+args.skip+'&orderBy='+args.orderBy+'&orderDirection='+args.orderDirection+'&userGroupId=9')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
 
  getTutors: ( ) => new Promise((resolve, reject) => {
    //?limit='+args.limit+'&skip='+args.skip+'&orderBy='+args.orderBy+'&orderDirection='+args.orderDirection+'&town='+args.town+'&countryId='+args.country
    console.log('gettuors')
    api.get('/users/filter/?userGroupId=9&limit=100')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getVenue: (id) => new Promise((resolve, reject) => {
    api.get('venues/' + id)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  createVenue: ({ ...args}) => new Promise((resolve, reject) => {
    var data = {}
    data.data = args
    api.post('venues/',data)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  deleteVenue: (arg) => new Promise((resolve, reject) => {
    api.post('venues/'+arg+'/delete')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  
  deleteTutor: (arg) => new Promise((resolve, reject) => {
    api.post('users/'+arg+'/delete')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  createTutor: ({ ...args}) => new Promise((resolve, reject) => {
    console.log(args)
    var data = {}
    data = args
    api.post('/users/create', data)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  getOrdersByClassroomId: (id) => new Promise((resolve, reject) => {
    api.get('/tc-orders/filter/?productVariantId=' + id + '&statuses=["fullyPaid","partiallyPaid","reserved"]')
    .then(function (response) {
        // console.log('departureinfo: ', response)
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  }),
  //getInvoiceByClassroomId
  getInvoiceByClassroomId: (id) => new Promise((resolve, reject) => {
    api.post('/invoices/filter/?productVariantId=' + id )
    .then(function (response) {
        // console.log('departureinfo: ', response)
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  }),
  generateRegisterPdf:(classroom) => new Promise((resolve, reject) => {
    reportApi.post('classroom/register',classroom,{responseType:'arraybuffer'})
    .then(function (response) {
      
    resolve(response)
  })
  .catch((error) => {
    reject(error)
  })
  }),
  emailAttendees:(...args) => new Promise((resolve, reject) => {
    console.log(args)
    serverApi.post('/sendmail/emailAttendees/',{email:args[0].message,attendees:args[0].attendees})
    .then(function (response) {
      
    resolve(response)
  })
  .catch((error) => {
    reject(error)
  })
  })
    
}
export default datas


// WEBPACK FOOTER //
// ./src/components/Classrooms/api.js